import type { IconProps } from "./types";

export default function PlantDiversityIcon({ size = 24, color = "currentColor", title, ...svgProps }: IconProps) {
    return (
        <svg
            viewBox="13 13 38 38"
            width={size}
            height={size}
            color={color}
            fill="none"
            role={title ? "img" : undefined}
            aria-hidden={title ? undefined : true}
            aria-label={title}
            xmlns="http://www.w3.org/2000/svg"
            {...svgProps}
        >
            {title ? <title>{title}</title> : null}
            <path d="M32 48V29" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
            <path d="M32 34C22.5 34 16.5 29 16 20c9.5 0 15.5 5 16 14Z" fill="currentColor" />
            <path
                d="M32 29c.7-9.3 6.8-14.3 16.5-14-.7 9.3-6.8 14.3-16.5 14Z"
                fill="currentColor"
                opacity=".82"
            />
            <path
                d="M32 43c-6.8-.2-11-3.8-11.2-10.2 6.8.2 11 3.8 11.2 10.2Z"
                fill="currentColor"
                opacity=".66"
            />
        </svg>
    );
}
